import { useReactMediaRecorder } from "react-media-recorder";
import React, { useEffect, useState, useContext } from "react";
import btnLoader from "../assets/btnLoader.svg";
import axios from "axios";
import AuthContext from "../context/userAuth.context";
import { Button } from "@mui/material";

import swal from "sweetalert";
import MicRecorder from "mic-recorder-to-mp3";
import { Mic, MicOff } from "@mui/icons-material";

const RecordView = (props) => {
  const [second, setSecond] = useState("00");
  const [minute, setMinute] = useState("00");
  const [isActive, setIsActive] = useState(false);
  const [counter, setCounter] = useState(0);
  const [showCountdown, setshowCountdown] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const { authenticationData, UserData } = useContext(AuthContext);
  const [blobURL, setBlobURL] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  // const Mp3Recorder = new MicRecorder({
  //   bitRate: 64,
  //   prefix: "data:audio/wav;base64,",
  // });

  const [Mp3Recorder, setMp3Recorder] = useState(
    new MicRecorder({ bitRate: 128 })
  );

  useEffect(() => {
    navigator.getUserMedia(
      { audio: true },
      () => {
        console.log("Permission Granted");
        setIsBlocked(false);
      },
      () => {
        console.log("Permission Denied");
        setIsBlocked(true);
      }
    );
  }, []);

  useEffect(() => {
    let intervalId;

    if (isActive) {
      intervalId = setInterval(() => {
        const secondCounter = counter % 60;
        const minuteCounter = Math.floor(counter / 60);

        let computedSecond =
          String(secondCounter).length === 1
            ? `0${secondCounter}`
            : secondCounter;
        let computedMinute =
          String(minuteCounter).length === 1
            ? `0${minuteCounter}`
            : minuteCounter;

        setSecond(computedSecond);
        setMinute(computedMinute);

        setCounter((counter) => counter + 1);
      }, 1000);
    }

    return () => clearInterval(intervalId);
  }, [isActive, counter]);

  function stopTimer() {
    setIsRecording(false);
    setIsDone(false);
    setIsActive(false);
    setCounter(0);
    setSecond("00");
    setMinute("00");
  }
  // const {
  //   status,
  //   startRecording,
  //   stopRecording,
  //   pauseRecording,
  //   mediaBlobUrl,
  // } = useReactMediaRecorder({
  //   video: false,
  //   audio: true,
  //   echoCancellation: true,
  // });
  // console.log("url", mediaBlobUrl);

  const sendAudioFile = async (file) => {
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    //var myFile = blobToFile(file, "rec.mp3");
    const audioBlob = await fetch(file).then((r) => r.blob());
    var uuid = Math.floor(100000 + Math.random() * 900000);
    const audioFile = new File([audioBlob], "Recording_" + uuid + ".mp3", {
      type: "audio/mp3",
    });

    var fd = new FormData();
    fd.append("file", audioFile);

    axios
      .post(authenticationData.ApiBaseURL + "/api/Export/UploadRecording", fd, {
        headers: {
          "Content-Type": `multipart/form-data`,
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      })
      .then((response) => {
        if (response.data.status == true) {
          swal(
            "Success",
            response.data.message +
              ", Go to 'Sounds' Panel from the left and look for it in 'Uploads' tab.",
            "success"
          );
          props.setshowRecording(false);
        } else swal("Failed", response.data.message, "error");
      });

    // return fetch('http://localhost:3000/audioUpload', {
    //   method: 'POST',
    //   body: formData
    // });
  };

  const closeRecording = () => {
    swal({
      title: "Are you sure you want to close this?",
      text: "You recording will not be saved.",
      icon: "warning",
      buttons: [true, "Yes, Close it!"],
      cancelButtonColor: "#d33",
      // confirmButtonText: "Yes, Clear it!",
      dangerMode: true,
      backdrop: null,
    }).then((willDelete) => {
      if (willDelete) {
        props.setshowRecording(false);
      }
    });
  };

  const record = {
    position: "relative",
    right: "-44px",
    borderRadius: "50px",
  };

  const stopStyle = {
    position: "relative",
    left: "65px",
    borderRadius: "50px",
  };

  const countdown = () => {
    setshowCountdown(true);
    var timeleft = 5;
    var downloadTimer = setInterval(function () {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
        setshowCountdown(false);
        start();
      } else {
        document.getElementById("countdown").innerHTML = timeleft + " seconds";
      }
      timeleft -= 1;
    }, 1000);
  };

  const start = () => {
    if (isBlocked) {
      console.log("Permission Denied");
    } else {
      setIsActive(!isActive);
      Mp3Recorder.start()
        .then(() => {
          setIsRecording(true);
        })
        .catch((e) => console.error(e));
    }
  };

  const stop = () => {
    setIsActive(false);
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const blobURL = URL.createObjectURL(blob);
        setBlobURL(blobURL);
        setIsRecording(false);
      })
      .catch((e) => console.log(e));
    setIsDone(true);
  };

  return (
    <div>
      {showCountdown && (
        <div className="CountdownWrapper">
          <span>Get ready!</span>
          <span>Recording starting in...</span>
          <div id="countdown">5 seconds</div>
        </div>
      )}

      <div className="RecordViewWrapper">
        {!isDone && (
          <>
            <div className="topMenu">
              <button className="btn btn-small btn-yellow" onClick={stopTimer}>
                Reset
              </button>
              <div className="closeRecord" onClick={closeRecording}>
                <span class="material-icons">close</span>
              </div>
            </div>

            <div className="RecordingTime">
              <div style={{ width: "120px" }}>
                <span className="minute">{minute}</span>
                <span>:</span>
                <span className="second">{second}</span>
              </div>

              <div className="recordingBtns ml-5">
                <button
                  disabled={isRecording}
                  className="btn btn-blue mr-2"
                  onClick={countdown}
                >
                  Start
                </button>
                <button
                  disabled={!isRecording}
                  className="btn btn-grey"
                  onClick={stop}
                >
                  Stop
                </button>

                {/* <Button
                variant="contained"
                style={record}
                color="primary"
                onClick={start}
                disabled={isRecording}
              >
                <Mic />
              </Button> */}
                {/* <Button
            disabled={!isRecording}
            style={stopStyle}
            variant="contained"
            color="primary"
            onClick={stop}
          >
            <MicOff />
          </Button> */}
              </div>
            </div>
          </>
        )}

        {isDone && (
          <div className="previewAudio">
            <div className="topMenu" style={{ justifyContent: "right" }}>
              <div className="closeRecord" onClick={closeRecording}>
                <span class="material-icons">close</span>
              </div>
            </div>

            <audio src={blobURL} controls="controls" />

            <div className="previewBtns">
              <button
                className="btn btn-grey mr-2"
                onClick={(e) => {
                  stopTimer();
                  setIsDone(false);
                }}
              >
                Retry
              </button>
              <button
                className="btn btn-blue "
                onClick={(e) => {
                  sendAudioFile(blobURL);
                }}
              >
                Save in Uploads
              </button>
            </div>
            {/* <button
              class="btn btn-blue"
              style={{ width: "100%" }}
              onClick={(e) => {
               
                sendAudioFile(blobURL);
              }}
            >
              Save to Uploads
             
            </button> */}
          </div>
        )}
      </div>
    </div>
  );
};
export default RecordView;
